import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import styles from './_WorkflowTarefaItemDescricao.less';
import PropTypes from "prop-types";

export default function WorkflowTarefaItemDescricao(props) {
  const { descricao, edicao, onEdicao, onSubmit, readOnly } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const fireEdicao = (edicao) => {
    if (readOnly)
      return;
    if (typeof onEdicao === 'function')
      onEdicao(edicao);
  }

  const fireSubmit = descricao => {
    let promise = Promise.resolve();
    if (typeof onSubmit === 'function')
      promise = promise.then(() => onSubmit(descricao));
    return promise;
  }

  const handleClick = e => {
    e.preventDefault();
    form.resetFields();
    fireEdicao(true);
  }

  const handleBlur = e => {
    fireEdicao(false);
  }

  const handleFinish = values => {
    fireSubmit(values.descricao).then(() => fireEdicao(false));
  }

  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="descricao" initialValue={descricao} noStyle>
          <Input autoFocus placeholder={t('Descrição')} onBlur={handleBlur}/>
        </Form.Item>
      </Form>
    );
  }

  let className = styles['workflow-tarefa-item-descricao'];
  if (!descricao)
    className += ' ' + styles['nao-preenchido'];
  if (readOnly)
    className += ' ' + styles['read-only'];

  return (
    <div className={className} onClick={handleClick}>
      {descricao ?? '(não preenchido)'}
    </div>
  );
}

WorkflowTarefaItemDescricao.propTypes = {
  descricao: PropTypes.string,
  edicao: PropTypes.bool,
  onEdicao: PropTypes.func,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool
}